import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
import { Well } from "components/bootstrap";
import usePluggableLicenseCheck from "hooks/usePluggableLicenseCheck";
const NewExampleWell = styled(Well)(
  ({ theme }) => css`
    margin-bottom: 5px;
    font-family: ${theme.fonts.family.monospace};
    font-size: ${theme.fonts.size.body};
    white-space: pre-wrap;
    overflow-wrap: break-word;
  `
);
const SlackNotificationDetails = ({ notification }) => {
  var _a, _b;
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.webhook_url_label"),
      value: notification.config.webhook_url
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("slack_notification_details.channel_label"), value: notification.config.channel }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.custom_message_label"),
      value: /* @__PURE__ */ React.createElement(NewExampleWell, { bsSize: "small" }, notification.config.custom_message || /* @__PURE__ */ React.createElement("em", null, t("slack_notification_details.empty_body")))
    }
  ), ((_b = (_a = usePluggableLicenseCheck("/license/security")) == null ? void 0 : _a.data) == null ? void 0 : _b.valid) && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.include_event_procedure_label"),
      value: notification.config.include_event_procedure
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.backlog_limit_label"),
      value: notification.config.backlog_size
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.user_name_label"),
      value: notification.config.user_name
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.include_title_label"),
      value: notification.config.include_title
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.notify_channel_label"),
      value: notification.config.notify_channel
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.link_names_label"),
      value: notification.config.link_names
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("slack_notification_details.icon_url_label"), value: notification.config.icon_url }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.icon_emoji_label"),
      value: notification.config.icon_emoji
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("slack_notification_details.time_zone_label"),
      value: notification.config.time_zone
    }
  ));
};
export default SlackNotificationDetails;
